import React from 'react';

import styles from './Index.module.css';
import header from '../../../assets/index/index_header.jpg';
import ornament from '../../../assets/deco/path60.svg';
import templateSimple1 from '../../../assets/index/template_simple_1.png';
import templateSimple2 from '../../../assets/index/template_simple_2.png';
import templateClassic1 from '../../../assets/index/template_classic_1.png';
import templateClassic2 from '../../../assets/index/template_classic_2.png';

const Index = () => {
  const handleClick = ($url) => {
    window.open($url);
  };

  const handleClickButton = ($url) => {
    window.location.href = `/wedding/${$url}`;
  };

  const handleClickDisabledButton = ($url) => {
    alert(`${$url}은 준비중입니다. 출시를 기다려 주세요!`);
  };

  return (
    <div className={styles.Index}>
      <div className={styles.box}>
        <div className={styles.header}>
          <img src={header} alt='header' />
        </div>
        <div className={styles.contents}>
          <section className={styles.ad}>
            <p>내 취향에</p>
            <p>
              <b>딱</b> <span className={styles.replace} />
            </p>
            <p>모바일 청첩장</p>
          </section>

          <section className={styles.title}>
            <p>맞춤형 모바일 청첩장 서비스</p>
            <p>Happy ever after</p>
          </section>

          <img src={ornament} alt='ornament' className={styles.ornament} />

          <section className={styles.sample_preview_mockup}>
            <div className={styles.templates_contents}>
              <p>⚫</p>
              <h3>Preview Gallery</h3>
              <div className={styles.buttons_wrapper}>
                <button
                  onClick={() => handleClickButton('template_simple_1')}
                  style={{
                    backgroundImage: `url(${templateSimple1})`,
                  }}
                >
                  <span>Simple 1</span>
                </button>
                <button
                  onClick={() => handleClickButton('template_simple_2')}
                  style={{
                    backgroundImage: `url(${templateSimple2})`,
                  }}
                >
                  <span>Simple 2</span>
                </button>
                <button
                  onClick={() => handleClickButton('template_classic_1')}
                  style={{
                    backgroundImage: `url(${templateClassic1})`,
                  }}
                >
                  <span>Classic 1</span>
                </button>
                <button
                  onClick={() => handleClickButton('template_classic_2')}
                  style={{
                    backgroundImage: `url(${templateClassic2})`,
                  }}
                >
                  <span>Classic 2</span>
                </button>

                <div className={styles.custom}>
                  템플릿을 원하는 대로 조립해
                  <br />
                  <span>나만의 청첩장</span>을 만들어 보세요!
                </div>
              </div>
            </div>
          </section>

          <img src={ornament} alt='ornament' className={styles.ornament} />

          <section className={styles.notice}>
            <p>전달받은 모바일 청첩장이 있으신가요?</p>
            <p>신랑/신부로부터 전달받은 링크를 클릭하시면</p>
            <p>모바일 청첩장을 확인하실 수 있습니다.</p>
          </section>
        </div>
        <div className={styles.footer}>
          <p>
            kmong “
            <span onClick={() => handleClick('https://kmong.com/')}>내 취향에 꼭 맞추는 모바일 청첩장 주문제작</span>”
          </p>
          <p>
            Designed & Developed by <b>Malg Eum Yu</b>
          </p>
        </div>
      </div>
    </div>
  );
};

export default Index;
